import {
  API_BASE_URL,
  API_KEY,
  CURRENT_MOVIES_ENDPOINT,
  GENRE_ENDPOINT,
  MOVIE_SEARCH_ALL_ENDPOINT,
} from "./config";
import { appState } from "./state";
import type {
  GenreResponse,
  MoviesResponse,
  ReviewsResponse,
  SimilarMoviesResponse,
  VideosResponse,
} from "./types";

export const searchMovieByQuery = async (searchString: string) => {
  const page = appState.getCurrentSearchPage();
  const url = `${API_BASE_URL}${MOVIE_SEARCH_ALL_ENDPOINT}?query=${searchString}&page=${page}&api_key=${API_KEY}`;
  console.log("Searching for movies with URL:", url);
  const matchingMovies = await fetch(url, {
    method: "GET",
    headers: { accept: "application/json" },
    cache: "force-cache",
  })
    .then((res) => res.json())
    .catch((error) => alert(error));

  return matchingMovies as MoviesResponse;
};

export const fetchCurrentMovies = async () => {
  const page = appState.getCurrentDefaultPage();
  const url = `${API_BASE_URL}${CURRENT_MOVIES_ENDPOINT}?page=${page}&api_key=${API_KEY}`;

  const currentMovies = await fetch(url, {
    method: "GET",
    headers: { accept: "application/json" },
    cache: "force-cache",
  })
    .then((res) => res.json())
    .catch((error) => alert(error));

  return currentMovies as MoviesResponse;
};

export const getMovieVideos = async (movieId: number) => {
  const url = `${API_BASE_URL}/movie/${movieId}/videos?api_key=${API_KEY}`;

  const movieVideos = await fetch(url, {
    method: "GET",
    headers: { accept: "application/json" },
    cache: "force-cache",
  })
    .then((res) => res.json())
    .catch((err) => console.error(err));

  return movieVideos as VideosResponse;
};

export const getMovieReviews = async (movieId: number) => {
  const url = `${API_BASE_URL}/movie/${movieId}/reviews?api_key=${API_KEY}`;

  const movieReviews = await fetch(url, {
    method: "GET",
    headers: { accept: "application/json" },
    cache: "force-cache",
  })
    .then((res) => res.json())
    .catch((err) => console.error(err));

  return movieReviews as ReviewsResponse;
};

export const returnMovieGenres = async () => {
  const url = `${API_BASE_URL}${GENRE_ENDPOINT}/list?api_key=${API_KEY}`;
  const genreData = await fetch(url, {
    method: "GET",
    headers: { accept: "application/json" },
    cache: "force-cache",
  })
    .then((res) => res.json())
    .catch((err) => console.error(err));

  return genreData as GenreResponse;
};

export const getSimilarMovies = async (movieId: number) => {
  const url = `${API_BASE_URL}/movie/${movieId}/similar?api_key=${API_KEY}`;

  const similarMovies = await fetch(url, {
    method: "GET",
    headers: { accept: "application/json" },
    cache: "force-cache",
  })
    .then((res) => res.json())
    .catch((err) => console.error(err));
  return similarMovies as SimilarMoviesResponse;
};

export const getAdditionalMovieInfo = async (movieId: number) => {
  try {
    const [videos, reviews, similarMovies] = await Promise.all([
      getMovieVideos(movieId),
      getMovieReviews(movieId),
      getSimilarMovies(movieId),
    ]);
    return { videos, reviews, similarMovies };
  } catch (err) {
    console.error("Failed to fetch additional movie info", movieId, err);
  }
  return;
};
